import React, { useContext, useEffect, useState } from 'react';

import { ServiceResponse } from '../../../app/services/shared/interfaces';

import { AppContext } from '../../../contexts/AppContext';
import { toast } from 'react-toastify';
import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';
import LazyLoading from '../../../components/LazyLoading';
import useServiceService from '../../../app/services/hooks/useServiceService';
import { ServiceDataForm, defaultServiceDataForm } from '../../../app/models/Service';
import { Sector } from '../../../app/models/Sector';
import ServiceFormContainer from './ServiceFormContainer';
import { Unit } from '../../../app/models/Unit';
import { Tax } from '../../../app/models/Tax';
import { ItemCategory } from '../../../app/models/ItemCategory';
import useWarehouseQuoteExtraService from '../../../app/services/hooks/useWareHouseQuoteExtraServicesService';

interface Props {
    onSaved?: () => void;
    onCancel?: () => void;
    onError?: () => void;
    autoLinkWithQuoteId?: number;
}

const ServiceCreate = ({ onSaved, onCancel, onError, autoLinkWithQuoteId }: Props) => {
    const { showLoading, hideLoading, changeAnimation } = useContext(AppContext);

    const [errorGetData, setErrorGetData] = useState('');
    const [service, setService] = useState<ServiceDataForm>(defaultServiceDataForm);
    const [sectors, setSectors] = useState<Sector[]>([]);
    const [itemCategories, setItemCategories] = useState<ItemCategory[]>([]);
    const[units,setUnits] =useState<Unit[]>([]);
    const [taxes, setTaxes] = useState<Tax[]>([]);
    const [quoteDetailFormTypes, setQuoteDetailFormTypes] = useState<{ id: string; name: string }[]>([]);
    const [errorFields, setErrorFields] = useState<any>();
    const { storeWarehouseExtraService } = useWarehouseQuoteExtraService();

    const { fetchingStoreService, storeService, createService, fetchingCreateService } =
        useServiceService();

    useEffect(() => {
        create();
    }, []);

    const create = () => {
        if (showLoading) showLoading('loading', 'Cargando datos...');
        createService({
            onSuccess: (response: ServiceResponse) => {
                setSectors(response.data.sectors);
                setItemCategories(response.data.item_categories);
                setUnits(response.data.units);
                setTaxes(response.data.taxes);
                setQuoteDetailFormTypes(response.data.quote_detail_form_types ?? []);
                if (hideLoading) hideLoading();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                toast.error(response.message);
                if (onError) onError();
            }
        });
    };

    const store = () => {
    console.log('🔗 autoLinkWithQuoteId:', autoLinkWithQuoteId);

    if (showLoading) showLoading('loading', 'Guardando servicio...');
        if (showLoading) showLoading('loading', 'Guardando servicio...');
        storeService(service, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                useReactConfirmAlert().successAlert({
                    title: 'Éxito',
                    message: response.message
                });
                toast.success(response.message, { autoClose: 2500 });

                const newService: ServiceDataForm = {
                    id: response.data.service_id,
                    name: service.name
                };

                if (autoLinkWithQuoteId && newService?.id) {
                    console.log('✅ Enviando extra service con:', {
                        quote_id: autoLinkWithQuoteId,
                        service_id: newService.id
                    });

                    storeWarehouseExtraService(
                        { quote_id: autoLinkWithQuoteId, service_id: newService.id },
                        {
                            onSuccess: (res) => {
                                toast.success(res.message);
                                if (onSaved) onSaved();
                            },
                            onError: (res) => {
                                toast.error(res.message);
                                if (onSaved) onSaved();
                            }
                        }
                    );
                } else {
                    if (onSaved) onSaved();
                }
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                useReactConfirmAlert().errorAlert({
                    title: 'Error',
                    message: response.message
                });
                if (onError) onError();
            },
            onFieldError: (errorFields: ServiceResponse) => {
                if (hideLoading) hideLoading();
                setErrorFields(errorFields.data);
            }
        });
    };

    const cancel = () => {
        if (onCancel) onCancel();
    };

    if (errorGetData !== '') {
        return <div>{errorGetData}</div>;
    }

    return fetchingCreateService ? (
        <LazyLoading height="300" />
    ) : (
        <ServiceFormContainer
            fetching={fetchingStoreService}
            sectors={sectors}
            itemCategories={itemCategories}
            units={units}
            taxesData={taxes}
            quoteDetailFormTypes={quoteDetailFormTypes}
            action={store}
            cancel={cancel}
            service={service}
            setService={setService}
            errorFields={errorFields}
        />
    );
};

export default ServiceCreate;
